import type { OfflineBehaviorView } from './types';

import { STORAGE_KEYS } from '~/constants/storageKeys';

const OFFLINE_BEHAVIOR_VIEWS_KEY = STORAGE_KEYS.OFFLINE_BEHAVIOR_VIEWS;
const MAX_OFFLINE_BEHAVIOR_VIEWS = 50;

export function getOfflineBehaviorViews(): OfflineBehaviorView[] {
	if (!import.meta.client) return [];
	try {
		const stored = localStorage.getItem(OFFLINE_BEHAVIOR_VIEWS_KEY);
		return stored ? JSON.parse(stored) : [];
	} catch {
		return [];
	}
}

export function saveOfflineBehaviorViews(views: OfflineBehaviorView[]): void {
	if (!import.meta.client) return;
	try {
		localStorage.setItem(
			OFFLINE_BEHAVIOR_VIEWS_KEY,
			JSON.stringify(views.slice(-MAX_OFFLINE_BEHAVIOR_VIEWS))
		);
	} catch {
		// localStorage unavailable
	}
}

export function clearOfflineBehaviorViews(): void {
	if (!import.meta.client) return;
	try {
		localStorage.removeItem(OFFLINE_BEHAVIOR_VIEWS_KEY);
	} catch {
		// localStorage unavailable
	}
}

export function saveBehaviorViewOffline(view: OfflineBehaviorView): void {
	const views = getOfflineBehaviorViews();
	const existingIndex = views.findIndex(
		v => v.propertyId === view.propertyId && v.viewType === view.viewType
	);

	if (existingIndex >= 0) {
		views[existingIndex] = view;
	} else {
		views.push(view);
	}

	saveOfflineBehaviorViews(views);
}

export function getOfflineBehaviorViewsCount(): number {
	return getOfflineBehaviorViews().length;
}
